import { CompanyDocumentRes } from '../../proxy/proxy';
import {
  CLEAR_ALL_DATA,
  COMPANY_DOCUMENT_LOAD_ALL,
  COMPANY_DOCUMENT_RESET_PAGE,
  COMPANY_DOCUMENT_GRID_SORT,
  COMPANY_DOCUMENT_GRID_CURRENT_PAGE,
  COMPANY_DOCUMENT_GRID_SEARCH_TEXT,
  COMPANY_DOCUMENT_CHANGE_STATE,
} from '../actionTypes';

export interface StateType {
  allRows: Array<CompanyDocumentRes>,
  filteredRows: Array<CompanyDocumentRes>,
  searchedText: string,
  currentPage: number,
  sortModel: Array<any>,
  states: Array<number>,
}

const INITIAL_STATE: StateType = {
  allRows: [],
  filteredRows: [],
  searchedText: '',
  currentPage: 0,
  sortModel: [],
  states: []
};

const filterRows = (allRows: Array<CompanyDocumentRes> = [], states: Array<number> = [], searchText = '') => {
  const text = searchText.trim();
  // const result = text ? allRows.filter((row) => {
  //   return false;
  // }) : allRows;
  return allRows;
};

const reducer = (state = INITIAL_STATE, action: { type: string, data: any }): StateType => {
  switch (action.type) {
    case COMPANY_DOCUMENT_LOAD_ALL:
      return {
        ...state,
        allRows: action.data || [],
        filteredRows: filterRows(action.data || [], state.states, state.searchedText),
      };
    case COMPANY_DOCUMENT_RESET_PAGE:
      return {
        ...INITIAL_STATE
      };
    case COMPANY_DOCUMENT_GRID_SORT:
      return {
        ...state,
        sortModel: action.data || []
      };
    case COMPANY_DOCUMENT_GRID_CURRENT_PAGE:
      return {
        ...state,
        currentPage: action.data
      };
    case COMPANY_DOCUMENT_GRID_SEARCH_TEXT:
      return {
        ...state,
        searchedText: action.data,
        filteredRows: filterRows(state.allRows, state.states, action.data),
        currentPage: 0
      };
    case COMPANY_DOCUMENT_CHANGE_STATE:
      return {
        ...state,
        states: action.data,
        filteredRows: filterRows(state.allRows, action.data, state.searchedText),
        currentPage: 0
      };
    case CLEAR_ALL_DATA:
      return INITIAL_STATE;

    default: return state;
  }
};

export default reducer;
